const PAGES = {
  MENU_SCREEN_MAIN: "MENU_SCREEN_MAIN",
  MENU_SCREEN_LOGIN: "MENU_SCREEN_LOGIN",
  MENU_SCREEN_SIGNUP: "MENU_SCREEN_SIGNUP",
  MENU_SCREEN_CHAMPIONS: "MENU_SCREEN_CHAMPIONS",
  LOBBY_SCREEN: "LOBBY_SCREEN",
  GAME_SCREEN: "GAME_SCREEN",
};

export default PAGES